<template>
  <div>
    <div :class="arrowClass"></div>
    <span class="wl-chosen-content">{{showText}} </span>
    <el-select v-model="value"
               @change="onChoosenValue"
               @visible-change="onDropDownChange"
               class="wl-select"
               :title='showText'
               placeholder="Select">
      <el-option v-for="item in options"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import * as _ from 'lodash';
export default {
    data() {
        return {
            value: this.getDefault(),
            dropDownVisible: true
        };
    },
    methods: {
        onChoosenValue(v) {
            const { row, column } = this.scope;
            const columnName = column['property'];
            this.onChange({
                [columnName]: v,
                id: row.id
            });
        },
        onDropDownChange(visible) {
            this.dropDownVisible = !visible;
        },
        getDefault() {
            const { row, column } = this.scope;
            const status = row[column['property']];
            const _v = _.filter(this.options, v => v.value === status);

            return _.get(_v, '[0].value');
        }
    },
    computed: {
        arrowClass() {
            const _className = 'wl-trangle ';
            return this.dropDownVisible ? _className : _className + ' up';
        },
        showText() {
            const _v = _.filter(this.options, v => v.value === this.value);

            return _.get(_v, '[0].label');
        }
    },
    watch: {
        options() {
            this.value = this.getDefault();
        }
    },
    props: {
        options: {
            type: Array,
            default: []
        },
        scope: {
            type: Object,
            default: {}
        },
        onChange: {
            type: Function,
            default: () => {}
        }
    }
};
</script>

<style scoped>
.wl-select {
    opacity: 0;
}
.wl-trangle {
    position: absolute;
    right: 4px;
    top: 50%;
    width: 0;
    height: 0;
    border-width: 0 8px 12px;
    border-style: solid;
    border-color: transparent transparent #000;
    transform: translate(0, -50%) rotate(180deg) scale(0.5);
    transition: transform 0.3s linear;
}
.wl-trangle.up {
    transform: translate(0, -50%) rotate(0deg) scale(0.5);
}
.wl-chosen-content {
    position: absolute;
    display: inline-block;
    width: 16px;
    height: 16px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    text-align: left;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
